import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ThemeSpace } from '../../../theme/spaces'
import { ThemeColor } from '../../../theme/colors'

export interface LoadingIndicatorProps {
  size?: ThemeSpace
  color?: ThemeColor
  centerize?: boolean
}

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const StyledLoadingRingPart = styled.div<{
  $size: ThemeSpace
  $color: ThemeColor
  $delay?: string
}>`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${({ $size, theme }) =>
    $size ? theme.space[$size] : theme.space.s32};
  height: ${({ $size, theme }) =>
    $size ? theme.space[$size] : theme.space.s32};
  border: ${({ theme }) => theme.space.s2} solid;
  border-radius: 50%;
  animation: ${rotation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: ${({ $delay }) => $delay};
  border-color: ${({ theme, $color }) =>
      $color ? theme.color[$color] : theme.color.primary110}
    transparent transparent transparent;
`

export const StyledLoadingIndicator = styled.div<{
  $size?: ThemeSpace
  $centerize: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: ${({ $size, theme }) =>
    $size ? theme.space[$size] : theme.space.s32};
  height: ${({ $size, theme }) =>
    $size ? theme.space[$size] : theme.space.s32};
  margin: ${({ theme, $centerize }) =>
    $centerize ? `${theme.space.s8} auto` : `${theme.space.s8} 0`};
`
export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  color = 'primary110',
  size = 's32',
  centerize = true,
  ...props
}) => (
  <StyledLoadingIndicator {...props} $size={size} $centerize={centerize}>
    <StyledLoadingRingPart $color={color} $size={size} $delay="-0.45s" />
    <StyledLoadingRingPart $color={color} $size={size} $delay="-0.3s" />
    <StyledLoadingRingPart $color={color} $size={size} $delay="-0.15s" />
    <StyledLoadingRingPart $color={color} $size={size} />
  </StyledLoadingIndicator>
)
